import React from 'react';

const TelegramCircleIcon = (props: any) => {
  const { className, fillColor = 'none' } = props;

  return (
    (<svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      data-palette="TelegramCircleIcon">
      <g fill={fillColor}>
        <circle cx="19.858" cy="19.858" r="19.858" fill="#212A33" />
        <path
          fill="#FFF"
          d="M16.369 21.112l1.74 4.952 2.268-2.579L24.263 27 27 13l-14 6.635 3.369 1.477zm6.63-4.095l-4.285 4.447-.533 2.289-.986-2.806 5.804-3.93z"
        />
      </g>
    </svg>)
  );
};

export default TelegramCircleIcon;
